import React from 'react';
import { Box, Typography, CircularProgress, Alert, Fade } from '@mui/material';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

/**
 * Live PDF pane. The iframe keeps showing the previous render while the next
 * one builds — swapping to a spinner on every keystroke would make the panel
 * strobe. A small badge signals that a rebuild is in flight instead.
 */
const QuotePdfPreview = ({ url, building, error, hasLines }) => (
  <Box sx={{ position: 'relative', height: '100%', backgroundColor: '#eef0f3', display: 'flex', flexDirection: 'column' }}>
    <Box sx={{
      px: 2, py: 1, borderBottom: '1px solid #e5e7eb', backgroundColor: 'white',
      display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0, minHeight: 41,
    }}>
      <DescriptionOutlinedIcon fontSize="small" sx={{ color: '#845adf' }} />
      <Typography variant="caption" sx={{ fontWeight: 700, color: '#374151', letterSpacing: 0.3 }}>
        LIVE PREVIEW
      </Typography>
      <Fade in={building}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, ml: 'auto' }}>
          <CircularProgress size={11} sx={{ color: '#845adf' }} />
          <Typography variant="caption" sx={{ color: '#9ca3af', fontSize: 10.5 }}>updating…</Typography>
        </Box>
      </Fade>
    </Box>

    <Box sx={{ flex: 1, minHeight: 0, position: 'relative' }}>
      {error && (
        <Alert severity="error" sx={{ m: 2, fontSize: 12 }}>{error}</Alert>
      )}

      {!error && !hasLines && (
        <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', px: 3, textAlign: 'center' }}>
          <DescriptionOutlinedIcon sx={{ fontSize: 46, color: '#cbd0d6', mb: 1 }} />
          <Typography variant="body2" sx={{ color: '#6b7280', fontWeight: 600 }}>Nothing to preview yet</Typography>
          <Typography variant="caption" sx={{ color: '#9ca3af', mt: 0.5 }}>
            Add a product and the quotation will render here as you type.
          </Typography>
        </Box>
      )}

      {!error && hasLines && !url && (
        <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CircularProgress size={26} sx={{ color: '#845adf' }} />
        </Box>
      )}

      {!error && url && (
        <iframe
          title="quote-live-preview"
          src={`${url}#toolbar=0&navpanes=0&view=FitH`}
          style={{ width: '100%', height: '100%', border: 0, display: 'block' }}
        />
      )}
    </Box>
  </Box>
);

export default QuotePdfPreview;
